import * as z from 'zod'

import { LOCALES } from '@/lib/localization/constants'
import { UTMDataSchema } from '@/lib/gtm'

export const schema = z.object({
  resourceTitle: z.string(),
  companyEmail: z
    .string()
    .nonempty({ message: 'Company email is required' })
    .email({ message: 'Must be valid email' }),
  companyName: z.string().nonempty({ message: 'Company name is required' }),
  firstName: z.string().nonempty({ message: 'First name is required' }),
  lastName: z.string().nonempty({ message: 'Last name is required' }),
  tel: z
    .string()
    .nonempty({ message: 'Phone number is required' })
    .regex(/^\d{10}$/, {
      message: 'Phone number must be a 10-digit number',
    }),
  jobTitle: z.string(),
  services: z.object({
    implementation: z.boolean(),
    advisory: z.boolean(),
    training: z.boolean(),
    legal: z.boolean(),
    compliance: z.boolean(),
    dpo: z.boolean(),
  }),
  acceptedTerm: z.boolean(),
  agreedToMarketingConsent: z.boolean(),
  turnstileToken: z.string().optional(),
  url: z.string().optional(),
})

export type FormValue = z.infer<typeof schema>

export const payloadSchema = schema.extend({
  language: z.enum(LOCALES),
  utm: UTMDataSchema,
})

export type PayloadValue = z.infer<typeof payloadSchema>
